import React, { Component } from 'react';
import {
  Button,
  Modal,
  FormGroup,
  FormControl,
  ControlLabel /* ,
  Panel */
} from 'react-bootstrap';
/* import { Link } from 'react-router-dom'; */
import { API, Auth } from 'aws-amplify';
import './FreeAccountModal.css';
import PaymentButton from '../containers/PaymentButton';

export default class FreeAccountModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isProcessingPayment: false,
      /* desiredType: 'Enterprise', */
      comments: '',
      subscription: 'personal-yearly',
      username: ''
    };
  }

  async componentDidMount() {
    this.getUsername();
  }

  setProcessing() {
    this.setState({ isProcessingPayment: true });
  }

  getUsername = async event => {
    try {
      await Auth.currentAuthenticatedUser().then(data =>
        this.setState({ username: data.attributes.email })
      );
    } catch (e) {
      alert(e);
    }
  };

  renderPaymentButton() {
    if (this.state.subscription === 'personal-yearly') {
      return (
        <PaymentButton
          successCallback={this.handleSuccess}
          failureCallback={this.handleFailure}
          url="personalyearlysub"
          amount={15999}
          username={this.state.username}
          startProcessingCallback={this.setProcessing.bind(this)}
        />
      );
    } else if (this.state.subscription === 'personal-monthly') {
      return (
        <PaymentButton
          successCallback={this.handleSuccess}
          failureCallback={this.handleFailure}
          url="personalmonthlysub"
          amount={1399}
          username={this.state.username}
          startProcessingCallback={this.setProcessing.bind(this)}
        />
      );
    } else if (this.state.subscription === 'student-yearly') {
      if (
        this.state.username.endsWith('.ac.uk') ||
        this.state.username.endsWith('.edu')
      ) {
        return (
          <PaymentButton
            successCallback={this.handleSuccess}
            failureCallback={this.handleFailure}
            url="studentpersonalyearlysub"
            amount={7499}
            username={this.state.username}
            startProcessingCallback={this.setProcessing.bind(this)}
          />
        );
      } else {
        return (
          <p>
            You must have a recognised student email address in order to sign up
            for this subscription.
          </p>
        );
      }
    } else if (this.state.subscription === 'student-monthly') {
      if (
        this.state.username.endsWith('.ac.uk') ||
        this.state.username.endsWith('.edu')
      ) {
        return (
          <PaymentButton
            successCallback={this.handleSuccess}
            failureCallback={this.handleFailure}
            url="studentpersonalmonthlysub"
            amount={699}
            username={this.state.username}
            startProcessingCallback={this.setProcessing.bind(this)}
          />
        );
      } else {
        return (
          <p>
            You must have a recognised student email address in order to sign up
            for this subscription.
          </p>
        );
      }
    }
  }

  createEstimate(estimate) {
    return API.post('va-estimator', '/va-estimator', {
      body: estimate
    });
  }

  handleSuccess = async result => {
    console.log(result);
    console.log('attempting to save estimate now');

    /*     this.props.upgrade();
    this.props.save(); */
    try {
      await this.createEstimate(this.props.estimatetosave);
    } catch (error) {
      console.error(error);
    }
    alert(
      'Your account has been successfully upgraded and your estimate has been saved.'
    );
    /* this.setAccountType(); */
    this.props.history.push('/beta');
    window.location.reload();
  };

  /*   setAccountType = async event => {
    let user = await Auth.currentAuthenticatedUser();
    const accttype = user.attributes['custom:type'];
    if (accttype !== undefined) {
      this.setState({ accountType: accttype });
    } else {
      this.setState({ accountType: 'free' });
    }
  };
 */
  handleFailure = error => {
    alert(
      'Something has gone wrong and your subscription has not been processed.'
    );
    console.error(error);
  };

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleSubmit = async event => {
    event.preventDefault();

    let user = await Auth.currentAuthenticatedUser();
    try {
      await this.sendEnquiry({
        name: user.attributes['custom:name'],
        email: user.attributes['email'],
        company: user.attributes['custom:company'],
        country: user.attributes['custom:country'],
        desiredType: 'Enterprise',
        comments: this.state.comments
      });
      this.props.onHide();
      alert(
        'Thank you for your enquiry. The Digimasters team will be in touch shortly.'
      );
    } catch (e) {
      console.error(e);
    }
  };

  sendEnquiry(enquiry) {
    return API.post('va-estimator', '/va-estimator/enquire', {
      body: enquiry
    });
  }

  renderPaymentContent() {
    return (
      <div>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            Free Account Tier Limits
          </Modal.Title>
          <p>
            As a free account holder, you cannot save estimates to your account.
            If you would like to use this feature and save '
            {this.props.estimatename}
            ', please upgrade your account using the form below.
          </p>
          {/*           <p>
        If you would like to enquire about upgrading to student or
        enterprise accounts, please fill the form below.
      </p> */}
        </Modal.Header>
        <Modal.Body>
          <FormGroup controlId="subscription">
            <ControlLabel>Choose Subscription:</ControlLabel>
            <FormControl
              componentClass="select"
              onChange={this.handleChange}
              value={this.state.subscription}
              type="string">
              <option value="personal-yearly">Personal (£159.99/Year)</option>
              <option value="personal-monthly">Personal (£13.99/Month)</option>
              <option value="student-yearly">Student (£74.99/Year)</option>
              <option value="student-monthly">Student (£6.99/Month)</option>
            </FormControl>
          </FormGroup>
          {this.renderPaymentButton()}
          {/*           <Panel defaultExpanded={false}>
        <Panel.Heading>
          <Panel.Title toggle>Enquiry Form</Panel.Title>
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            <form onSubmit={this.handleSubmit}>
              <h3>Contact Digimasters</h3>
              <FormGroup controlId="desiredType">
                <ControlLabel>Interested In Upgrading To:</ControlLabel>
                <FormControl
                  componentClass="select"
                  onChange={this.handleChange}
                  value={this.state.desiredType}
                  type="string">
                  <option value="personal">
                    Personal (£13.99/Month or £159.99/Year)
                  </option>
                  <option value="enterprise">
                    Enterprise (£91.99/Month or £919.99/Year)
                  </option>
                  <option value="student">Student</option>
                </FormControl>
              </FormGroup>
              <FormGroup controlId="comments">
                <ControlLabel>Comments:</ControlLabel>
                <FormControl
                  componentClass="textarea"
                  placeholder=""
                  onChange={this.handleChange}
                  value={this.state.comments}
                />
              </FormGroup>
              <Button bsStyle="success" bsSize="large" type="submit">
                Submit
              </Button>
            </form>
          </Panel.Body>
        </Panel.Collapse>
      </Panel> */}
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="danger" onClick={this.props.onHide}>
            Cancel
          </Button>
        </Modal.Footer>
      </div>
    );
  }

  renderPaymentProcessingScreen() {
    return (
      <Modal.Body>
        <h1>Processing payment, please wait a few seconds...</h1>
      </Modal.Body>
    );
  }

  render() {
    return (
      <Modal
        {...this.props}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg">
        {this.state.isProcessingPayment
          ? this.renderPaymentProcessingScreen()
          : this.renderPaymentContent()}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FreeAccountModal.js